module.exports = __webpack_public_path__ + "static/media/aldi1.bb923ad6.jpg";